import React from "react";
import { clearImpersonation } from "../utils/session";
import { useTranslate } from "../i18n";
import { getRoleLabel } from "../i18n/helpers";

const IcoExit = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3H4a1 1 0 00-1 1v12a1 1 0 001 1h4M13 14l4-4-4-4M17 10H7" />
  </svg>
);

function ImpersonationBanner({ tenantName, userName, userRole, onExit }) {
  const { t } = useTranslate();

  const handleExit = () => {
    clearImpersonation();
    onExit();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: "linear-gradient(90deg, #f59e0b, #d97706)",
        color: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "7px 20px",
        fontSize: 12,
        fontWeight: 600,
      }}
    >
      <span>
        {t("shared.impersonation.loggedInAs")} <strong>{userName}</strong>
      </span>
      <span style={{ opacity: 0.6 }}>·</span>
      <span>{getRoleLabel(t, userRole)}</span>
      <span style={{ opacity: 0.6 }}>·</span>
      <span>{tenantName}</span>
      <button
        className="e-mobile-action"
        onClick={handleExit}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          background: "rgba(0,0,0,0.15)",
          border: "1px solid rgba(0,0,0,0.2)",
          borderRadius: 6,
          padding: "3px 10px",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          color: "#000",
          fontFamily: "inherit",
          marginLeft: 4,
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "rgba(0,0,0,0.25)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "rgba(0,0,0,0.15)")
        }
      >
        <IcoExit /> {t("shared.impersonation.exit")}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
